import { useApp } from "@/App";
import { useTranslation } from "react-i18next";

/**
 * QR maintenance switch, as served by the backend in /api/config.
 *
 * The flag is read at runtime, so turning maintenance back off is a backend
 * change only — the mini-app does not need a rebuild to start taking payments
 * again.
 *
 * `qr_maintenance_message` is an optional operator override. When it is empty
 * the notice falls back to our own translated copy, which is the normal case.
 */
export const useQrMaintenance = () => {
  const { config } = useApp();
  const { t } = useTranslation();

  const active = Boolean(config?.qr_maintenance);
  const override = String(config?.qr_maintenance_message || "").trim();

  return {
    active,
    title: t("qr.maintenance_title"),
    text: override || t("qr.maintenance_text"),
    short: override || t("qr.maintenance_short"),
  };
};

export default useQrMaintenance;
